import { createContext, useContext, useState, ReactNode } from "react";
import { setShowBrokenLinkDialog } from "../Services/BrokenLinkDialogHelper.tsx";
import React from "react";

type BrokenLinkDialogContextType = {
  showDialog: () => void;
  hideDialog: () => void;
  visible: boolean;
  throughWCvisible?: boolean;
  setThroughWCvisible: (value: boolean) => void;
};

const BrokenLinkDialogContext = createContext<BrokenLinkDialogContextType | undefined>(undefined);

export const useBrokenLinkDialog = () => {
  const context = useContext(BrokenLinkDialogContext);
  if (!context) {
    throw new Error("useBrokenLinkDialog must be used within a BrokenLinkDialogProvider");
  }
  return context;
};

export const BrokenLinkDialogProvider = ({ children }: { children: ReactNode }) => {
    const [visible, setVisible] = useState(false);
    const [throughWCvisible, setThroughWCvisibleState] = useState(false);
  
    const showDialog = () => setVisible(true);
    const hideDialog = () => setVisible(false);

    const setThroughWCvisible = (value: boolean) => setThroughWCvisibleState(value);
  
    React.useEffect(() => {
      setShowBrokenLinkDialog(showDialog);
    }, []);
  
    return (
      <BrokenLinkDialogContext.Provider value={{ showDialog, hideDialog, visible, throughWCvisible,  setThroughWCvisible }}>
        {children}
      </BrokenLinkDialogContext.Provider>
    );
};